import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";


export interface ResetOrderHistoryState {
    customFiltersOpen : boolean;
}

const initialState: ResetOrderHistoryState = {
    customFiltersOpen : false
};

const ChangeOrderHistoryReducer = {

    "Custom/OrderHistory/ToggleFiltersOpen": (draft: Draft<ResetOrderHistoryState>) => {
        draft.customFiltersOpen = !draft.customFiltersOpen;
    },

    "Custom/OrderHistory/ResetFiltersOpen": (draft: Draft<ResetOrderHistoryState>,) => {
        draft.customFiltersOpen = false;
    },
  
};

export default createTypedReducerWithImmer(initialState, ChangeOrderHistoryReducer);
